import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import SectionHeading from "@/components/feature/SectionHeading";

export default function CategoryGrid() {
  return (
    <section className="mx-auto max-w-[1280px] px-4 md:px-8 py-12 md:py-16">
      <SectionHeading
        title="动漫分类快捷入口"
        subtitle="按题材快速进入，找到你喜欢的动漫类型"
        icon="ri-apps-2-line"
        moreTo="/category/hot-blood"
        moreLabel="全部分类"
      />
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
        {categories.map((cat) => (
          <Link
            key={cat.key}
            to={`/category/${cat.key}`}
            className="group relative rounded-lg overflow-hidden h-32 md:h-40 border border-background-200/70 hover:border-primary-300 transition-all"
          >
            <img
              src={cat.cover}
              alt={`${cat.name}动漫分类`}
              title={`${cat.name} - 动漫全集`}
              className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/30 to-transparent" />
            <div className="relative h-full flex flex-col justify-end p-4">
              <h3 className="font-heading font-bold text-background-50 text-base md:text-lg">
                {cat.name}
              </h3>
              <p className="text-background-100/80 text-xs mt-1 clamp-2 hidden sm:block">{cat.desc}</p>
              <span className="text-primary-300 text-[11px] mt-2 flex items-center gap-1">
                {cat.count} 部作品
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}